import React, { useEffect } from "react";
import useFetchData from "../../hooks/useFetchData";
import AddOnsItem from "./AddOnsItem/AddOnsItem";
import Spinner from "../../components/Spinner/Spinner";
import { useSelector } from "react-redux";
import { pushEvent, optionCatalogItem } from "../../utils/datalayer";

function AddOns() {
  const { loading } = useFetchData(`/hotel/active`);
  const { options } = useSelector((state) => state.options);

  useEffect(() => {
    if (!Array.isArray(options) || options.length === 0) return;
    const items = options
      .filter((o) => o && o.display_in_list)
      .map((o, idx) => optionCatalogItem(
        { code: o.code, label: o.name_fr, price: o.unit_price },
        "options_catalog",
        idx,
      ))
      .filter(Boolean);
    if (items.length) {
      pushEvent("view_item_list", items, undefined, {
        item_list_name: "options_catalog",
      });
    }
  }, [options]);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="border bg-white rounded p-5">
          <div className="grid sm:grid-cols-2 justify-center gap-10 md:gap-5 xl:grid-cols-3 pb-8 ">
            {options?.map((item, i) => (
              <AddOnsItem item={item} key={i} i={i} />
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default AddOns;
